import { FC } from 'react';

const ProductCardLoading: FC = () => {
  return (
    <div className='col-span-1 m-auto flex aspect-[1/1.3] w-full max-w-76.5 flex-col'>
      <div className='loading-color-transition mb-4 aspect-square w-full rounded-md' />
      <div className='loading-color-transition mb-2 h-5 w-full' />
      <div className='flex flex-row items-center justify-between'>
        <div className='loading-color-transition h-5 w-1/3 p-1' />
        <div className='loading-color-transition h-5 w-[20%] p-1' />
      </div>
      <div className='loading-color-transition visible mt-8 h-12 w-full rounded-[4.75rem] lg:invisible' />
    </div>
  );
};

export default ProductCardLoading;
